const CardSkeleton = () => (
  <div className="shrink-0 w-[140px]">
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="aspect-[4/3] skeleton-base rounded-none" />
      <div className="px-2.5 py-2 space-y-1.5">
        <div className="h-3 skeleton-base w-[90%]" />
        <div className="h-2.5 skeleton-base w-[50%]" />
      </div>
    </div>
  </div>
);

const SlimCardSkeleton = () => (
  <div className="shrink-0 w-[110px]">
    <div className="bg-card rounded-lg border border-border/50 overflow-hidden">
      <div className="aspect-[3/2] skeleton-base rounded-none" />
      <div className="px-2 py-1.5 space-y-1">
        <div className="h-2.5 skeleton-base w-[85%]" />
        <div className="h-2 skeleton-base w-[40%]" />
      </div>
    </div>
  </div>
);

const CollectionSkeleton = () => (
  <div className="shrink-0 w-[130px]">
    <div className="relative overflow-hidden rounded-2xl aspect-[3/4] w-full skeleton-base" />
  </div>
);

const HomePageSkeleton = () => (
  <div className="page-padding pt-5 pb-24 space-y-6">
    {/* Header */}
    <div className="flex items-center justify-between">
      <div className="space-y-1.5">
        <div className="h-6 skeleton-base w-40" />
        <div className="h-4 skeleton-base w-28" />
      </div>
      <div className="w-10 h-10 skeleton-base rounded-xl" />
    </div>

    {/* Search bar */}
    <div className="h-12 skeleton-base rounded-2xl" />

    {/* Banner */}
    <div className="aspect-[16/9] skeleton-base rounded-2xl" />

    {/* Continue watching */}
    <div className="space-y-2">
      <div className="h-3 skeleton-base w-36" />
      <div className="flex gap-2.5 overflow-hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <SlimCardSkeleton key={i} />
        ))}
      </div>
    </div>

    {/* My contents */}
    <div className="space-y-3">
      <div className="h-5 skeleton-base w-32" />
      <div className="space-y-2">
        <div className="h-4 skeleton-base w-40" />
        <div className="flex gap-2.5 overflow-hidden">
          {Array.from({ length: 3 }).map((_, i) => (
            <CardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>

    {/* Collections */}
    <div className="space-y-3">
      <div className="h-5 skeleton-base w-28" />
      <div className="flex gap-3 overflow-hidden">
        {Array.from({ length: 3 }).map((_, i) => (
          <CollectionSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);

export default HomePageSkeleton;
